const Alert = ({ message, isSuccess = false }) => {
    if (!message) return null; // No message, no alert
  
    return (
      <div style={{
        padding: "10px",
        border: "1px solid "+isSuccess ? 'green': "green",
        backgroundColor: isSuccess ? 'green': "#f8d7da",
        color: isSuccess? '#fff': "#721c24",
        borderRadius: "5px",
        margin: "15px 0"
      }}>
        {message}
      </div>
    );
};

export default Alert;